import ImgNews from './ImgNews';
import TextNews from './TextNews';
import ThemeDayNews from './ThemeDayNews';
import Activity from './Activity';
import SubForum from './SubForum';
import Company from './Company';
import ClassRoom from './ClassRoom';
import Title from './Title';
import Forum from './Forum';
import Exposition from './Exposition';
import VideoMatch from './VideoMatch';

export {
  ImgNews,
  TextNews,
  ThemeDayNews,
  Activity,
  Forum,
  SubForum,
  Company,
  ClassRoom,
  Title,
  Exposition,
  VideoMatch,
}
